import dayjs from 'dayjs';
import { DaySelectOption } from './ScrollContainer';

export function getYearsRange() {
  const now = new Date();
  const startYear = now.getFullYear() - 20;
  const endYear = now.getFullYear() + 20;

  const yearsArray: DaySelectOption[] = [];
  for (let year = startYear; year <= endYear; year++) {
    yearsArray.push({
      value: String(year)
    });
  }

  return yearsArray;
}

/**
 * 년 월에 해당하는 day리스트 반환
 * @param year
 * @param month
 * @returns
 */
export function getDayOptions(year: number | string, month: number | string) {
  const daysInMonth = dayjs(`${year}-${month}`).daysInMonth();

  return Array.from({ length: daysInMonth }, (_, index) => ({
    value: `${index + 1}`
  }));
}
